import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InteractionType, ItemsDisplayType, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;
  businessId = ''; itemsDisplayType: ItemsDisplayType = ItemsDisplayType.OnlyBusiness;

  constructor(public localService: LocalService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.businessId = routeParams.businessId;
      this.ctryCode = routeParams.ctryCode;

      if (this.userId) {
        this.userId = routeParams.userId;
        this.interactionType = routeParams.interactionType;
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onLoad();
      } else {
        this.onLoad();
      }
    });
  }

  onLoad() {

  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.itemsDisplayType = ItemsDisplayType.OnlyBusiness;
      } break;
      case 2: {
        this.itemsDisplayType = ItemsDisplayType.ProductsForMultiBusinesses;
      } break;
    }
  }
}
